import { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { data } from "jquery";
// import DataTable from "datatables.net";
import { MainArea, MainAreaHeader, MainAreaBody } from "../../layout/MainArea";
import { getDataTableDom, requestToServer } from "../../utils/appUtils";
import TableDT from "../../UI/TableDT";
import { GetKKCinfo } from "../../../api";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

// const ROUTE_URL = "/get_conn_vpy";
const ROUTE_URL = "/get_conn_lsn";

function VpyData(props) {
    clearInterval(window.timer)
    const [serverData, setServerData] = useState(null);
    const { showErrorPage, messageBox } = useOutletContext();
    const navigate = useNavigate();
    const token = localStorage.getItem('token')
    const [arrTable, setArrTable] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState();

    const handleAddRow = () => {
        navigate("./create");
    };

    useEffect(() => {
        let offset = (currentPage - 1) * 10;
        GetKKCinfo(token, offset, 10).then((e) => {
            console.log(e.data.data);
            e.data.data.forEach((e) => {
                e.timestamp = new Date(e.timestamp).toLocaleString()
            });
            
            setArrTable(e.data.data)
        })
        if (!date) {
            setDate(Date.now())
        }
    }, [currentPage])


    const handleClick = (event) => {
        if (loading) return;
       event && event.preventDefault();
       event && event.target.blur();
        //    refreshData();
        let offset = (currentPage - 1) * 10;
        GetKKCinfo(token, offset, 10).then((e) => {
            console.log(e.data.data);
            e.data.data.forEach((e) => {
                e.timestamp = new Date(e.timestamp).toLocaleString()
            });
            
            setArrTable(e.data.data)
        })
        setLoading(true);
        setDate(Date.now())
        setTimeout(() => {
          setLoading(false);
        }, 650);
    }
    // const handleAfterDTCreate = ({ DOM, Api }) => {
    //     dtTable.Api = Api;
    //     $(DOM).on('click', 'tbody button[name="btnDelete"]', function (e) {
    //         e.preventDefault();
    //         let data = dtTable.Api.row($(this).parents('tr')).data();
    //         let urlDelete = ROUTE_URL + "/" + data.id;
    //         messageBox({
    //             show: true, message: `Вы действительно хотите удалить "${data.name}"?`, mbOk: (e) => {
    //                 e.preventDefault();
    //                 messageBox({ show: false, mbOk: null });
    //                 requestToServer(urlDelete, { method: 'DELETE' }, () => { dtTable.Api.ajax.reload(); }, (error) => { alert(JSON.stringify(error)); }, false);
    //             }
    //         });
    //     });
    //     $(DOM).on('click', 'tbody a[name="btnShowEdit"]', function (e) {
    //         e.preventDefault();
    //         let data = dtTable.Api.row($(this).parents('tr')).data();
    //         let urlStr = "./" + data.id;
    //         navigate(urlStr);
    //     });

    // }

    useEffect(() => {
        requestToServer(ROUTE_URL + "?crud", { method: 'GET' }, setServerData, showErrorPage, true);
    }, []);


    if (serverData === null)
        return <MainArea loading />;

    return (
        <MainArea>
            <MainAreaHeader caption="ККС" />
            <MainAreaBody containerClass="">
                <div className="container-fluid px-3 py-1 dashboard">
                    <div className="row g-3">  
                        <div className="cont-table">
                            <DataTable removableSort emptyMessage="Нет данных" value={arrTable} tableStyle={{ minWidth: '50rem' }}>
                                {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                <Column field="type" sortable header="Тип сообщения"></Column>
                                <Column field="timestamp" sortable header="Время обновления"></Column>
                                <Column field="normal_duration" sortable header={`Время нахождения ККС в состоянии «Исправен»"`}></Column>
                                <Column field="normal_psats_count" sortable header={`Количество МС в состоянии «Исправен»`}></Column>
                            </DataTable>
                            <div className="paginator">
                                <button
                                disabled={currentPage <= 1}
                                className="btn"
                                onClick={() => {
                                    setCurrentPage(currentPage - 1);
                                }}
                                >
                                {"<"}
                                </button>
                                <div className="text">{currentPage}</div>
                                <button
                                disabled={arrTable?.length < 10}
                                className="btn"
                                onClick={() => {
                                    setCurrentPage(currentPage + 1);
                                }}
                                >
                                {">"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div> 
    
              <div className="lower-line">
                                <div className="text-cont">
                                    <div className="text">Состояние актуально на:</div>
                                    <div className="text">{date ? new Date(date).toLocaleString() : ""}</div>
                                </div>
                                <Button className="btn-reload" loading={loading} label="Обновить сейчас" rounded onClick={handleClick}/>
                          </div>
            </MainAreaBody>
        </MainArea>
    );
}

// let dtTable = {
//     Api: null,
//     getTableOptions: (crud) => {
//         const dtOptions = {
//             ordering: true, lengthChange: true, filter: true, paging: true, info: true, processing: true,
//             order: [[1, "asc"]],
//             ajax: { type: "GET", url: ROUTE_URL + "?kks_info" },
//             dom: getDataTableDom("lfip", 2, 1),
//             columns: [
//                 { data: "timestamp", title: "Временная метка", render: DataTable.render.datetime(), },
//                 { data: "type", title: "Тип", render: DataTable.render.text(), },
//                 { data: "status", title: "Статус", render: DataTable.render.text(), },
//                 { data: "normal_duration", title: "Время нахождения ЛСН в состоянии «норма»", render: DataTable.render.number(), },
//                 { data: "normal_psats_count", title: "Количество МС (ЛСН) в состоянии «норма»", render: DataTable.render.number(), },
//             ],
//         };
//         if ((crud & 1) === 0) {
//             dtOptions.order = [[0, "asc"]];
//             dtOptions.columns.splice(0, 1);
//             dtOptions.dom = getDataTableDom("lfip", 1, 1);
//         }

//         console.log('dtOptions', dtOptions);


//         return dtOptions;
//     }
// };

// let dtTable = {
//     Api: null,
//     getTableOptions: (crud) => {
//         const dtOptions = {
//             ordering: true, lengthChange: true, filter: true, paging: true, info: true, processing: true,
//             order: [[1, "asc"]],
//             ajax: { type: "GET", url: ROUTE_URL + "?kks_status" },
//             dom: getDataTableDom("lfip", 2, 1),
//             columns: [
//                 // { orderable: false, searchable: false, data: null, className: "dt-center td-btn-action", render: DataTable.render.btnDelete(), },
//                 // { data: "timestamp", title: "Временная метка", render: DataTable.render.datetime(), },
//                 { data: "status", title: "Состояние системы ЛСН", render: DataTable.render.number(), },
//                 { data: "normal_duration", title: "Время нахождения ЛСН в состоянии 'норма'", render: DataTable.render.number(), },
//                 { data: "normal_psats_count", title: "Количество МС в состоянии 'норма'", render: DataTable.render.text(), },
//                 { data: "sensors", title: "Значение датчиков", render: DataTable.render.text(), },
//             ],
//         };
//         if ((crud & 1) === 0) {
//             dtOptions.order = [[0, "asc"]];
//             dtOptions.columns.splice(0, 1);
//             dtOptions.dom = getDataTableDom("lfip", 1, 1);
//         }

//         console.log('dtOptions', dtOptions);


//         return dtOptions;
//     }
// };

export default VpyData;
